import controller from './go-to-offers-dialog.controller';

export default {
  controller,
  template: require('./go-to-offers-dialog.html')
};


// WEBPACK FOOTER //
// src/app/no-auth/components/go-to-offers-dialog/go-to-offers-dialog.component.ts